import { useEffect, useMemo, useRef } from "react";
import { Field } from "formik";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import useTranslate from "../../../hooks/use-translate.hook";
import { Checkbox, MaskInput, TemplateEditor } from "../../../ui";
import css from "./template.scss";

const FileModelFooter = ({ form, open, onClose }) => {
    const t = useTranslate();

    const editor = useRef( null );

    const footerHeight = useMemo( () => form.values.footerHeight, [ form.values.footerHeight ] );
    const footerMargin = useMemo( () => form.values.footerMargin, [ form.values.footerMargin ] );

    const handleCancel = () => {
        onClose();
        form.setFieldValue( "footer", form.initialValues.footer );
    };

    useEffect( () => {
        if ( footerHeight && editor?.current ) {
            editor.current.iframeElement.style.height = `${footerHeight}cm`;
        }
    }, [ footerHeight ] );
    useEffect( () => {
        if ( footerMargin && editor?.current ) {
            editor.current.editorContainer.style.width = footerMargin ? "21cm" : "23cm";
        }
    }, [ footerMargin ] );

    return (
        <Dialog open={ open } classes={{ paper: css.fileModelHeaderContainer }} disableEnforceFocus maxWidth="lg">
            <DialogTitle>
                { t( "config:files.model.footer" ) }
            </DialogTitle>
            <DialogContent>
                <Field
                    name="footerMargin"
                    type="checkbox"
                    label={ t( "config:files.model.footer-margin" ) }
                    component={ Checkbox }
                />
                <Field
                    name="footerHeight"
                    label={ t( "config:files.model.footer-height" ) }
                    component={ MaskInput }
                    suffix=" cm"
                    required
                />
                <Field
                    name="footer"
                    component={ TemplateEditor }
                    style={
                        `body { overflow: hidden; height: ${footerHeight}cm; }`
                    }
                    showVariables={ false }
                    height={ footerHeight ? `calc(${footerHeight}cm + 86px + 25px + 32px)` : "0cm" }
                    width={ footerMargin ? "21cm" : "23cm" }
                    setup={ config => {
                        config.on( "init", ed => {
                            ed.target.editorCommands.execCommand(
                                "fontName", false, "Roboto, Helvetica, Arial, sans-serif"
                            );
                            ed.target.editorCommands.execCommand( "fontSize", false, "12pt" );
                            ed.target.editorCommands.execCommand( "fontWeight", false, "400" );
                            editor.current = ed.target;
                        });
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button color="primary" onClick={ handleCancel }>
                    { t( "common:cancel" ) }
                </Button>
                <Button color="primary" onClick={ onClose }>
                    { t( "common:confirm" ) }
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default FileModelFooter;